(function () {
    'use strict';

    class InteractiveOnboardingListController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            $translate,
            $state,
            $timeout,
            $,
            _,
            AppStates,
            EventService,
            OnboardingService,
            SetupGuideService,
            AnalyticsService,
            Enums,
            DeviceService
        ) {
            super($scope, $injector);
            this.__objectType = 'InteractiveOnboardingListController';

            this._ = _;
            this.$ = $;
            this.$timeout = $timeout;
            this.$translate = $translate;
            this.$state = $state;
            this.AppStates = AppStates;
            this.EventService = EventService;
            this.SetupGuideService = SetupGuideService;
            this.OnboardingService = OnboardingService;
            this.AnalyticsService = AnalyticsService;
            this.Enums = Enums;
            this.isMobile = DeviceService.nxSmallBreakpoint();

            this.AnalyticsService.trackPageView(
                this,
                this.AnalyticsService.analytics_events.setup_guide,
                {
                    source: 'setup_guide_interactive',
                    setup_guide_variant: 'setup_guide_interactive',
                    phase: 'activation'
                }
            );

            this.isSequenceComplete = true;

            this.stepViewData = {
                subscribe: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_SUBSCRIBE._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_SUBSCRIBE._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_SUBSCRIBE._CTA_',
                    analytics: 'pricing',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_navigation_settings_companySettings_subscription);
                    },
                },
                account: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_IN_LIST._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_IN_LIST._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_IN_LIST._CTA_',
                    analytics: 'account',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_navigation_settings_account);
                    },
                },
                templates: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_TEMPLATES._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_TEMPLATES._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_TEMPLATES._CTA_',
                    analytics: 'templates',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_navigation_templates);
                    },
                    secondaryCtaText: 'INTERACTIVE_ONBOARDING.STEP_TEMPLATES._LINK_',
                    secondaryAnalytics: 'account setup',
                    secondaryCtaAction: () => {
                        this.goToState(this.AppStates.root_core_accountSetup);
                    }
                },
                account_setup: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_SETUP._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_SETUP._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_ACCOUNT_SETUP._CTA_',
                    analytics: 'account setup',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_accountSetup);
                    },
                },
                bank_info: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_BANK_INFO._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_BANK_INFO._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_BANK_INFO._CTA_',
                    analytics: 'bank account',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_navigation_settings_company_bankInfo);
                    },
                },
                contact_form: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_CONTACT_FORM._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_CONTACT_FORM._TEXT_',
                    ctaText: 'INTERACTIVE_ONBOARDING.STEP_CONTACT_FORM._CTA_',
                    analytics: 'contact form',
                    ctaAction: () => {
                        this.goToState(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
                    },
                },
                cha_ching: {
                    title: 'INTERACTIVE_ONBOARDING.STEP_CHA_CHING._TITLE_',
                    text: 'INTERACTIVE_ONBOARDING.STEP_CHA_CHING._TEXT_',
                },
            };

            this.proTipBoldText = $translate.instant('INTERACTIVE_ONBOARDING._PRO_TIP_');
            this.proTipText = $translate.instant('INTERACTIVE_ONBOARDING._PRO_TIP_TEXT');
            this.proTipLinkTitle = $translate.instant('INTERACTIVE_ONBOARDING._PRO_TIP_LINK_TEXT');
        }

        $onInit() {
            const lastStep = this._.max(this.steps, step => step.order);

            const chaChingStep = {
                key: 'cha_ching',
                status: 'pending',
                score: 0,
                order: (lastStep.order + 1)
            };

            this.stepsWithViewData = this.steps
                .concat(chaChingStep)
                .map(step => {
                    const stepViewData = this.stepViewData[step.key];
                    return this._.extend(step, stepViewData);
                });

        }

        handleCloseMwebWizard() {
            this.completeMwebWizard();
        }

        proTipLinkClick() {
            this.$state.go(this.AppStates.root_core_navigation_settings_company_general);
        }
    }

    Components.InteractiveOnboardingList = {
        controller: InteractiveOnboardingListController,
        controllerAs: 'interactiveOnboardingListVm',
        bindings: {
            steps: '<',
            currentStep: '<',
            isCollapsed: '<',
            isSequenceComplete: '<',
            isMarkedComplete: '=',
            handleMarkedComplete: '&',
            completeMwebWizard: '&'
        },
        name: 'hbInteractiveOnboardingList',
        require: {
            hbInteractiveOnboarding: '^hbInteractiveOnboarding'
        },
        templateUrl: 'angular/app/modules/core/features/onboarding/interactive_onboarding/int_onb_list/int_onb_list.html',
    };
}());
